import React, { Fragment, useCallback } from 'react';
import DisplayRichTextString from 'components/RichTextEditorField/components/DisplayRichTextString';
import { countTextLengthFromJson } from 'components/RichTextEditorField/utils';
import {
  checkIsTextValidJSON,
  getHrefFromUrl,
  isUrl as isUrlFunc,
} from 'utils';
import { NEW_WINDOW_PROPS } from 'data/global';

export default function useDisplayMessage() {
  const getIsJson = useCallback(
    (text: string) => checkIsTextValidJSON(text),
    [],
  );

  const getIsEmpty = useCallback(
    (text: string) =>
      getIsJson(text) ? !countTextLengthFromJson(text) : !text,
    [getIsJson],
  );

  const renderText = useCallback(
    (text: string) => {
      if (getIsEmpty(text)) return null;

      if (getIsJson(text))
        return <DisplayRichTextString>{text}</DisplayRichTextString>;

      const words = text?.split(' ').map((el: string) => ({
        el,
        isUrl: isUrlFunc(el),
      }));

      return words.map(({ el, isUrl }) =>
        isUrl ? (
          <Fragment key={el}>
            <a
              href={getHrefFromUrl(el)}
              onClick={(e) => e.stopPropagation()}
              {...NEW_WINDOW_PROPS}
            >
              {el}
            </a>
            {` `}
          </Fragment>
        ) : (
          `${el} `
        ),
      );
    },
    [getIsEmpty, getIsJson],
  );

  return { getIsEmpty, renderText };
}
